import { render, staticRenderFns } from "./AnotherCasesCard.vue?vue&type=template&id=070172ba"
import script from "./AnotherCasesCard.vue?vue&type=script&lang=js"
export * from "./AnotherCasesCard.vue?vue&type=script&lang=js"
import style0 from "./AnotherCasesCard.vue?vue&type=style&index=0&id=070172ba&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports